import React, { useState, useEffect } from "react";
import { FaEdit, FaPlus } from "react-icons/fa";
import { toast } from "react-toastify";
import "./CategoryForm.css"; 
import Modal from '../components/modal/modal';  
import CustomToastContainer from '../components/ToastMessage/ToastContainer'; 
import API_URLS from '../summaryapi/apiUrls';
import { RingLoader } from 'react-spinners'; // Import the spinner

function CategoryForm() {
  const [categories, setCategories] = useState([]);
  const [formData, setFormData] = useState({
    category_name: "",
    description: "",
    category_img: null,
    isActive: false, 
  });
  const [imagePreview, setImagePreview] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    setLoading(true); // Set loading to true when fetching starts
    try {
      const response = await fetch(API_URLS.getAllServiceCategories.url);
      if (!response.ok) throw new Error(`Error: ${response.status}`);
      const data = await response.json();
      setCategories(data.data);
    } catch (error) {
      toast.error("Failed to load categories.");
    } finally {
      setLoading(false); // Set loading to false after fetching
    }
  };

  const handleChange = ({ target: { name, value, type, checked } }) => {
    setFormData(prevData => ({
      ...prevData,
      [name]: type == 'checkbox' ? checked : value
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    const allowedTypes = ['image/jpeg', 'image/png', 'image/gif'];

    if (file && allowedTypes.includes(file.type)) {
      setFormData({ ...formData, category_img: file });
      const preview = URL.createObjectURL(file);
      setImagePreview(preview);
    } else {
      toast.error("Please select a valid image file (jpeg, png, gif).");
    }
  };

  

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    if (!formData.category_name || !formData.description) {
      toast.error("Category Name and Description are required.");
      setLoading(false);
      return;
    }
  
    const body = new FormData();
    body.append('category_name', formData.category_name);
    body.append('description', formData.description);
    body.append('isActive', formData.isActive ? '1' : '0');

    if (isEditing) {
      const categoryId = categories[editIndex]?.category_id;
      if (categoryId) {
        body.append('category_id', categoryId);
      } else {
        toast.error("Category ID not found for editing.");
        setLoading(false);
        return;
      }
    }
    
    if (formData.category_img) {
      body.append('category_img', formData.category_img);
    }
  
    try {
      const url = isEditing
        ? API_URLS.updateServiceCategory.url
        : API_URLS.createServiceCategory.url;

      const method = isEditing ? API_URLS.updateServiceCategory.method : API_URLS.createServiceCategory.method;

      const response = await fetch(url, {
        method,
        body,
      });
  
      if (!response.ok) {
        const errorMessage = await response.json();
        throw new Error(`Failed: ${errorMessage.message || response.status}`);
      }
  
      await fetchCategories();
      toast.success(`Category ${isEditing ? 'updated' : 'added'} successfully!`);
    } catch (error) {
      console.error("Error saving category:", error);
      toast.error(`Failed to save category: ${error.message}`);
    } finally {
      setLoading(false);
      resetForm();
    }
  };

  const resetForm = () => {
    setFormData({ category_name: "", description: "", category_img: null, isActive: false });
    setImagePreview(null);
    setIsAddModalOpen(false);
    setIsEditModalOpen(false);
    setIsEditing(false);
    setEditIndex(null);
  };

  const handleEdit = (index) => {
    setIsEditing(true);
    setEditIndex(index);
    const categoryToEdit = categories[index];
    setFormData({
      category_name: categoryToEdit.category_name,
      description: categoryToEdit.description,
      isActive: categoryToEdit.isActive == "1",
    });
    setImagePreview(`${API_URLS.getCategoryImages.url}/${categoryToEdit.category_img}`);
    setIsEditModalOpen(true);
  };


  return (
    <div>
      <div className="header">
        <h2 className="text-center" style={{color: '#8A2BE2'}}>Categories</h2>
        <button onClick={() => setIsAddModalOpen(true)} className="add-category-button">
          <FaPlus /> Add Category
        </button>
      </div>

      {loading ? (
        <div className="loading-container">
          <RingLoader color="#3498db" loading={loading} size={50} />
          <h3 style={{color: '#8A2BE2'}}>Loading categories...</h3>
        </div>
      ) : categories.length === 0 ? (
        <p className="text-center">No categories added yet.</p>
      ) : (     <div>
        <div className="categories-table-container" style={{ maxHeight: categories.length > 8 ? '600px' : 'none', overflowY: 'auto' }}>
        <table className="categories-table">
          <thead>
          <tr>
    <th style={{ textAlign: 'center' }}>Image</th>
    <th style={{ textAlign: 'center' }}>Category Name</th>
    <th style={{ textAlign: 'center' }}>Description</th>
    <th style={{ textAlign: 'center' }}>Is Active</th>
    <th style={{ textAlign: 'center' }}>Actions</th>
  </tr>
          </thead>
          <tbody>
  {categories.map((category, index) => (
    <tr key={category.category_id} style={{ textAlign: 'center' }}>
      <td style={{ textAlign: 'center' }}>
        <img
          src={`${API_URLS.getCategoryImages.url}/${category.category_img}`}
          alt={category.category_name}
          style={{ maxWidth: '100px', maxHeight: '100px', objectFit: 'cover' }}
        />
      </td>
      <td style={{ textAlign: 'center' }}><strong>{category.category_name}</strong></td>
      <td style={{ textAlign: 'center' }}>{category.description}</td>
      <td style={{ textAlign: 'center', color: category.isActive === "1" ? 'green' : 'red' }}>
  {category.isActive === "1" ? 'Yes' : 'No'}
</td>

      <td style={{ textAlign: 'center' }}>
  <div 
    style={{
      backgroundColor: 'green',
      color: '#fff',
      borderRadius: '5px',
      padding: '8px',
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      transition: 'background-color 0.3s, transform 0.3s', // Add transition for both background-color and zoom effect
    }}
    onClick={() => handleEdit(index)}
    onMouseEnter={(e) => {
      e.target.style.backgroundColor = '#45a049'; // Change background color on hover
      e.target.style.transform = 'scale(1.1)';    // Zoom in the div on hover
    }}
    onMouseLeave={(e) => {
      e.target.style.backgroundColor = 'green'; // Reset background color when hover ends
      e.target.style.transform = 'scale(1)';    // Reset zoom on hover end
    }}
  >
    <FaEdit style={{ fontSize: '16px' }} />
  </div>
</td>



    </tr>
  ))}
</tbody>

        </table>
        
    
      </div>
          <div className="services-footer">
          <p className="text-end">Total Categories: {categories.length}</p>
        </div>        </div>
      )}

      <Modal isOpen={isAddModalOpen || isEditModalOpen} onClose={resetForm}>
        <form onSubmit={handleSubmit}>
          <div className="modal-title">{isEditing ? 'Edit Category' : 'Add Category'}</div>
          <div className="form-group">
            <label htmlFor="category_name">Category Name</label>
            <input
              type="text"
              id="category_name"
              name="category_name"
              value={formData.category_name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="description">Description</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="category_img">Category Image</label>
            <input   style={{ maxWidth: "200px" }}
              type="file"
              id="category_img"
              onChange={handleImageChange}
            />
            {imagePreview && <img src={imagePreview} alt="Preview" className="image-preview" />}
          </div>




  <div className="toggle-container2">
  <label htmlFor="isActive">Active</label>
    <input
      type="checkbox"
      id="isActive"
      name="isActive"
      checked={formData.isActive}
      onChange={handleChange}
      className="toggle-input"
    />
    <label htmlFor="isActive" className="toggle-label">
      <span className="toggle-switch" />
    </label>
  </div>

          <div className="button-container-center">
          <button
  type="submit"
  className="submit-button"
  disabled={loading}
>
  {loading ? 'Saving...' : isEditing ? 'Update' : 'Add'}
</button>

          </div>
        </form>
      </Modal>

      <CustomToastContainer />
    </div>
  );
}

export default CategoryForm;
